import React from 'react';
import { Link } from 'react-router-dom';
import PageWrapper from '../../components/page-wrapper/page-wrapper';
import { useAuth } from '../../context/AuthContext';

const AdminDashboard = () => {
  const { currentUser } = useAuth();

  return (
    <PageWrapper>
      <div className="container mt-5 pt-5">
        <div className="row">
          <div className="col-12">
            <h1 className="mb-4">Admin Dashboard</h1>
            <div className="alert alert-info">
              <p>Welcome, {currentUser?.email}! You are logged in as an administrator.</p>
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-md-4 mb-4">
            <div className="card h-100">
              <div className="card-body">
                <h5 className="card-title">Blog Management</h5>
                <p className="card-text">Create, edit, and manage blog posts for the website.</p>
                <Link to="/admin/blogs" className="btn btn-primary">Manage Blogs</Link>
              </div>
            </div>
          </div>

          <div className="col-md-4 mb-4">
            <div className="card h-100">
              <div className="card-body">
                <h5 className="card-title">User Management</h5>
                <p className="card-text">Manage user accounts and permissions.</p>
                <Link to="/admin/users" className="btn btn-primary">Manage Users</Link>
              </div>
            </div>
          </div>

          <div className="col-md-4 mb-4">
            <div className="card h-100">
              <div className="card-body">
                <h5 className="card-title">Site Settings</h5>
                <p className="card-text">Configure website settings and preferences.</p>
                <Link to="/admin/settings" className="btn btn-primary">Site Settings</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default AdminDashboard;